export const getTextPositions = (
  source: string,
  selected: string
): { start: number; end: number } => {
  if (!selected) return { start: -1, end: -1 };

  const start = source.indexOf(selected);
  const end = start === -1 ? -1 : start + selected.length;

  return { start, end };
};
